import React from 'react';
import classnames from 'classnames';

const InForfaitCheckbox = ({ value }) => {
  if (typeof value === 'undefined' || value === null) return null;
  const checked = value === 'true' || (value !== 'false' && !!value);
  return <i className={classnames('fa fa-fw', checked ? 'fa-check-square-o' : 'fa-square-o')} />;
};
export default InForfaitCheckbox;
